import React from 'react';
import classnames from 'classnames';
import UnavailableSVG from '../../../images/svg/icons8-unavailable';
import './column-with-unavailable-mark.scss';

interface IProps {
    isCancelled: boolean;
    children?: React.ReactNode;
    handleOpenPopover?: (event: React.MouseEvent) => void;
}

const ColumnWithUnavailableMark = (props: IProps) => {
    const { isCancelled, children, handleOpenPopover } = props;

    return (
        <div
            onClick={handleOpenPopover}
            className={classnames('column-with-unavailable-mark',
                { 'column-with-unavailable-mark--active': isCancelled },
                { 'column-with-unavailable-mark--hidden': !isCancelled })}
        >
            {isCancelled && <div className='column-with-unavailable-mark__error'>
                <UnavailableSVG />
            </div>}
            <div className='column-with-unavailable-mark__content'>{children}</div>
        </div>
    );
};

export default ColumnWithUnavailableMark;
